import { all, put, takeEvery, select } from 'redux-saga/effects'
import { getAppSettingApi, updateAppSettingApi } from '../../../helpers/appSettingApi'
import { getAppSetting, GET_APP_SETTING_SAGA, updateAppSetting, UPDATE_APP_SETTING_SAGA, LOAD_ORG_LOGO_SAGA } from './appSetting'
import { modules } from 'veritone-redux-common';
import _ from 'lodash'
import { showToast } from './notification'
import constants from '../../../helpers/constant'
import { loadMediaContentApi } from '../../../helpers/advertiserApi'
import { setTrafficChannels } from './trafficChannel/actions';
import { CAMPAIGN_ANALYTICS_TOPICS } from '../../../components/CampaignAnalyticsTopics/index';
import { sortCampaignAnalyticsTopics } from '../../../helpers/common';
import { setLocationGranularity } from './locationGranularity/actions';

const { config: { getConfig } } = modules;

export function* getAppSetttingSaga() {
    const config = yield select(getConfig);
    const response = yield getAppSettingApi(config.urlApi);
    const data = response.data;
    const results = _.get(data, 'results', []);
    const trafficChannelResult = _.get(data, 'trafficChannelResult', {});
    const trafficChannels = Object.values(trafficChannelResult);
    const locationGranularityResult = _.get(data, 'locationGranularityResult', {});
    const locationGranularity = Object.values(locationGranularityResult);
    const campaignAnalyticsTopics = sortCampaignAnalyticsTopics(results);
    let formatTopics= results.find(obj => obj.setting_name === CAMPAIGN_ANALYTICS_TOPICS);
    formatTopics.setting_value = campaignAnalyticsTopics;
    yield put(getAppSetting(results));
    yield put(setTrafficChannels(trafficChannels));
    yield put(setLocationGranularity(locationGranularity));
}

export function* updateAppSettingSaga(action) {
    const { appSetting } = action.payload;
    const config = yield select(getConfig);
    const response = yield updateAppSettingApi(config.urlApi, appSetting);
    if (response.error) {
        const message = _.get(response,
            "response.data.message.advertiser.running",
            "Update app configuration failed");
        const toastFail = {
            message,
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toastFail));
    } else {
        const toastSuccess = {
            message: "Update app configuration success",
            action: "Dismiss",
            type: constants.SUCCESS
        };
        yield put(showToast(toastSuccess));
        const data = response.data.data;
        const campaignAnalyticsTopics = sortCampaignAnalyticsTopics(data);
        let formatTopics= data.find(obj => obj.setting_name === CAMPAIGN_ANALYTICS_TOPICS);
        formatTopics.setting_value = campaignAnalyticsTopics;
        yield put(updateAppSetting(data));
    }


}

function* loadOrgLogoSaga() {
    
    const config = yield select(getConfig);
    const appSetting = yield select(state => state.appSetting.data);    
    const appSettingLogo = appSetting.filter(item => item.setting_name === "logo")[0];
    
    const TDOId = _.get(appSettingLogo, 'setting_value.TDOId', '');
    const url = _.get(appSettingLogo, 'setting_value.url', '');
    const loadedTimeTracking = _.get(appSettingLogo, 'setting_value.loadedTimeTracking', '');

    const newTimeTracking = (new Date()).getTime();
    let isExpired = true;
    
    if (loadedTimeTracking) {        
        const loadedTimeRange = (newTimeTracking - loadedTimeTracking)/1000;
        //TODO: get logoExpiredTimeRange (that client send when upload logo) from graphql/API
        isExpired = url && (loadedTimeRange > constants.DEFAULT_ORG_LOGO_EXPIRE_TIME);
    }
    if (!TDOId || !isExpired ) {
        return;
    }    
    
    const res = yield loadMediaContentApi(config.urlApi, TDOId);
    if (res && res.error) {
        const toast = {
            message: 'Error loading advertiser logo!',
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toast));
    } else {
        const updatedAppSettingLogo = {
            ...appSettingLogo,
            setting_value: {
                ...appSettingLogo.setting_value,
                url: res,
                loadedTimeTracking: newTimeTracking
            }
        }
        yield put(updateAppSetting([updatedAppSettingLogo]));
    }
}

export default function* auth() {
    yield all([
        takeEvery(GET_APP_SETTING_SAGA, getAppSetttingSaga),
        takeEvery(UPDATE_APP_SETTING_SAGA, updateAppSettingSaga),
        takeEvery(LOAD_ORG_LOGO_SAGA, loadOrgLogoSaga)
    ])
}